export default __webpack_public_path__ + "static/compareItemImg3-eb83144c9b836628258c7682fa173286.webp";